import { computed, type ComputedRef } from 'vue'

import { useRbac } from '@/features/account'
import { ALERTS_MANAGE_PERMISSION_KEY, ALERTS_PERMISSION_KEY } from '@/shared/config'

export interface UseAlertRbac {
  canView: ComputedRef<boolean>
  canManage: ComputedRef<boolean>
}

/**
 * `alerts` is the shipped view key. A dedicated manage key is not yet present in every backend
 * payload, so absence preserves legacy view=manage while an explicit value enables read-only RBAC.
 */
export function useAlertRbac(): UseAlertRbac {
  const rbac = useRbac()
  const canView = computed(() => rbac.isSysAdmin.value || rbac.hasPermission(ALERTS_PERMISSION_KEY))
  const canManage = computed(() => {
    if (rbac.isSysAdmin.value) return true
    if (
      Object.prototype.hasOwnProperty.call(rbac.permissions.value, ALERTS_MANAGE_PERMISSION_KEY)
    ) {
      return rbac.hasPermission(ALERTS_MANAGE_PERMISSION_KEY)
    }
    return canView.value
  })
  return { canView, canManage }
}
